<app-subscriber-select 
    [subscriberKey]="subscriberKey()"
    [id]="'subscriberKey'"
    [disabled]="isDisabled()"
    [placeHolder]="isDisabled() ? '' : null"
    [showClear]="showClear()"
    [includeInternalSubscriber]="includeInternalSubscriber()"
    (blur)="onBlur()"
    (subscriberKeyChange)="onSubscriberKeyChange($event)"

    />